import { render, staticRenderFns } from "./TheTenantLoginForm.vue?vue&type=template&id=0871bf44&scoped=true"
import script from "./TheTenantLoginForm.vue?vue&type=script&lang=js"
export * from "./TheTenantLoginForm.vue?vue&type=script&lang=js"
import style0 from "./TheTenantLoginForm.vue?vue&type=style&index=0&id=0871bf44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0871bf44",
  null
  
)

export default component.exports